
































import { Vue, Prop, Component, Emit } from 'vue-property-decorator';
import { mapGetters } from 'vuex';
import Title from '@/components/utils/Title.vue';
import Select from '@/components/utils/Select.vue';
import Table from '@/components/queuemanagement/branches/table/Table.vue';

@Component({
  components: {
    Title,
    Select,
    Table,
  },
})
export default class QueueBranches extends Vue {
  title: Object = {
    label: 'Référencement par antenne',
    description: `Cher administrateur, ici vous avez la possibilité de choisir
    l'antenne souhaitée pour visualiser les lignes référencées et le nombre d'enfants par ligne`,
  };

  brancheCurrent: any = null;

  queueLength: Number = 0;

  queueList: Array<any> = [];

  brancheList: Array<string> = [];

  brancheItemList: Array<any> = [];

  async mounted() {
    await this.$store.dispatch('queue/a_get_listWithChildren');
    await this.$store.dispatch('queue/a_get_length');
    await this.$store.dispatch('branche/a_init_Branches', false);
    this.queueLength = this.$store.getters['queue/length'];
    this.queueList = this.$store.getters['queue/list'].sort((firstLine: any, secondLine: any) => {
      const firstLineCreatedDate = new Date(firstLine.date_creation_pedibus).getTime();
      const secondLineCreatedDate = new Date(secondLine.date_creation_pedibus).getTime();
      return secondLineCreatedDate - firstLineCreatedDate;
    });
    const tempBrancheList = this.$store.getters['branche/list'];
    this.brancheItemList = tempBrancheList;
    tempBrancheList.forEach((element: any) => {
      this.brancheList.push(`${element.city} (${element.departmentNumber})`);
    });
  }

  async selectBranche(val: any) {
    if (val === '') {
      await this.$store.dispatch('queue/a_get_listWithChildren');
      await this.$store.dispatch('queue/a_get_length');
      this.queueLength = this.$store.getters['queue/length'];
      this.queueList = this.$store.getters['queue/list'];
    } else {
      this.brancheItemList.forEach(async (branche: any) => {
        if (val === `${branche.city} (${branche.departmentNumber})`) {
          if (this.brancheCurrent !== branche) {
            this.brancheCurrent = branche;
            await this.$store.dispatch('queue/a_get_listByBrancheWithChildren', { branche });
            await this.$store.dispatch('queue/a_get_listByBrancheLength', { branche });
            this.queueList = this.$store.getters['queue/listByBranche'];
            this.queueLength = this.$store.getters['queue/listByBrancheLength'];
          }
        }
      });
    }
  }
}
